<article class="content">
	<ng-content></ng-content>
</article>
